<script setup lang="ts">
import { PhxBox } from '@sg-core/src/View/Components/Atoms/Box';
</script>

<template>
  <PhxBox v-bind="$attrs">
    <slot />
  </PhxBox>
</template>
